/* Sets the placeholder on the Algolia autocomplete input once the app has mounted it inside the header search bar. */
(function () {
  var TEXT = 'Search products, SKU or MPN';
  function set() {
    var input = document.querySelector('.header__search-bar .aa-Input');
    if (!input) return false;
    input.setAttribute('placeholder', TEXT);
    input.setAttribute('aria-label', TEXT);
    return true;
  }
  function start() {
    if (set() || !('MutationObserver' in window)) return;
    var obs = new MutationObserver(function () { if (set()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
